import {API} from 'aws-amplify';

export const create = async (ceo) => API.put('eventmanagerAdminApi', `/ceos`, {body: ceo});

export const read = async () => API.get('eventmanagerAdminApi', '/ceos', {});

export const readOne = async (id) => API.get('eventmanagerAdminApi', `/ceos/${id}`, {});

export const update = async (ceo) => API.post('eventmanagerAdminApi', `/ceos`, {body: ceo});

export const del = async (id) => API.del('eventmanagerAdminApi', `/ceos/${id}`, {});
